import React, { useEffect, useState } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from "react-modal-video";
import { FiClock, FiUser, FiMessageCircle, FiHeart } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-up";
import Breadcrumb from "../elements/common/Breadcrumb";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import controllers from "../controllers/events";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Preloader from "../component/Preloader/Preloader";
import { useLoading } from "../LoadingContext";
import YouTubeEmbed from "./YouTubeEmbed/YouTubeEmbed";
import moment from "moment";

const NewsDetails = (Component) => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const postId = searchParams.get("id");
  const [data, setData] = useState(false);
  const { loading, setLoading } = useLoading();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  useEffect(() => {
    setLoading(true);
    const getEventDetails = () => {
      if (postId && postId != null) {
        return controllers
          .getEventDetails(postId)
          .then((response) => {
            setData(response);
          })
          .catch((error) => {
            window.location.href = "/404";
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false); // set loading to false when data is fetched
            }, 4000);
          });
      } else {
        setLoading(false);
        window.location.href = "/404";
      }
    };
    setTimeout(() => {
      getEventDetails();
    }, 800);
  }, [postId]);

  if (loading) {
    return <Preloader />;
  }

  return (
    <React.Fragment>
      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      {data && (
        <>
          <Breadcrumb
            parent={"Collaboration et partenariatss"}
            title={isEnglish ? data.title.en : data.title.fr}
          />
         
          <div className="rn-news-details pt--70 pb--70 bg_color--1">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="inner-wrapper">
                    <div className="inner">
                      <div className="thumbnail">
                        <img
                          src={`${process.env.REACT_APP_DOMAIN}/api/eventsimages/${data.event_id}/${data.image}`}
                          alt="News Images"
                          style={{
                            width: "70%",
                            margin: "0 auto",
                            display: "block",
                          }}
                        />
                      </div>
                      <div className="mt--40">
                        <b>
                          {" "}
                          {isEnglish
                            ? "Publication Date"
                            : "Date de publication "}{" "}
                          : {moment(data.date).format("DD MMM,YYYY")}
                        </b>
                        <br />
                        {data.duration &&
                          data.duration.startDate &&
                          data.duration.endDate && (
                            <div className="font-weight-bold">
                              {isEnglish ? "Duration" : "Durée"} :{" "}
                              {moment(data.duration.startDate).format(
                                "DD MMM,YYYY"
                              )}{" "}
                              {" - "}
                              {moment(data.duration.endDate).format(
                                "DD MMM,YYYY"
                              )}
                            </div>
                          )}
                      </div>{" "}
                      <p className="mt--10">
                        {isEnglish ? (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: data.description.en,
                            }}
                            className=""
                          ></p>
                        ) : (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: data.description.fr,
                            }}
                            className=""
                          ></p>
                        )}
                      </p>
                      {data.link && (
                        <div className="text">
                          <b>
                            {isEnglish
                              ? "Pour plus d'informations: "
                              : "For more informations: "}
                          </b>
                          <a href={data.link} rel="noreferrer" target="_blank">
                            {data.link}
                          </a>
                        </div>
                      )}
                      {data.video && (
                        <div className="YouTubeEmbed">
                          <div className="text mb--10">
                            <b>
                              {isEnglish
                                ? "Click for the video !"
                                : "Cliquez pour la vidéo !"}
                            </b>
                          </div>
                          <YouTubeEmbed url={data.video} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div className="backto-top">
            <ScrollToTop showUnder={160}>
              <FiChevronUp />
            </ScrollToTop>
          </div>
        </>
      )}
      <Footer />
    </React.Fragment>
  );
};
export default NewsDetails;
